import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';
import { ArtworkArtist as Name } from '@components/artworkCard/artworkCard.styles';
import { FONT_SIZE, FONT_WEIGHT, typography } from '@theme/font';

import { Item, List } from '../grid.styles';

export const GridList = styled(List)`
  ${media.tablet} {
    margin: 0 ${OFFSET.M};
  }
`;

export const GridWrapper = styled.div`
  width: calc(50vw - ${OFFSET.S} - ${OFFSET.S} / 2);
  margin-bottom: ${OFFSET.L};

  ${media.mobile} {
    width: unset;
  }

  .slick-slide img {
    display: inline-block;
  }
`;

export const SectionTitle = styled.h4`
  ${typography({ size: FONT_SIZE.S, weight: FONT_WEIGHT.REGULAR })};
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const GridItem = styled(Item)`
  width: auto;
  padding: 0 5px 0;

  ${media.tablet} {
    padding: 0 ${OFFSET.XS} 0;
  }
`;

export const ArtworkArtist = styled(Name)`
  display: none;

  ${media.desktop} {
    display: block;
  }
`;

export const imageStyles = css`
  height: 90px;
  object-fit: contain;
  max-width: 100%;

  ${media.tablet} {
    height: 250px;
    width: 250px;
    max-width: 500px;
  }
`;
